import * as React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Translate } from '../../../shared/LanguageService';

interface IProps {
    filename: string;
    fileReference: string;
    onClose: () => void;
}

const ImageModal = (props: IProps) => {
    const { apiUrl } = window.appConfig;

    return (
        <Modal show={true} onHide={props.onClose} bsSize="large" className="plan-image-modal">
            <Modal.Header closeButton>
                <Modal.Title>{props.filename}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="plan-image-modal-body">
                <img
                    className="responsive-image-down"
                    src={`${apiUrl}/file/${props.fileReference}`}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.onClose}>
                    {Translate('view-order/admin-planorder/templates/image-modal/close')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ImageModal;
